export const VIEW_REGIME_ARROW_STEP_NEXT = 1

export const VIEW_REGIME_ARROW_STEP_PREVIOUS = -1

export const VIEW_REGIME_ARROW_STEP_NONE = 0
